/**
 * PLEASE do not use Mixins anymore,
 * If you are going to add a new method in this mixin consider UPGRADE THIS CODE to a high order component
 *
 */
const FormMixin = {
    _composite:function(obj){
        for (var prop in this) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && (prop.charAt(0) !== '_')) {
                obj[prop]=this[prop];
            }
        }
        return obj;
    },
    getFields: function () {
        let fields = [];
        let refs = Object.keys(this.refs);

        refs.forEach(function (name) {
            if (name.indexOf('field_') == 0) {
                fields.push(this.refs[name])
            }
        }.bind(this))
        return fields;
    },
    isValid: function () {
        let fields = this.getFields();
        let valid = true;

        fields.forEach(function (field) {
            if (!field.isValid()) {
                valid = false;
            }
        });

        return valid;
    }
};
/**
 * PLEASE do not use Mixins anymore,
 * If you are going to add a new method in this mixin consider UPGRADE THIS CODE to a high order component
 *
 */
const ValidMixin = {
    _composite:function(obj){
        for (var prop in this) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && (prop.charAt(0) !== '_')) {
                obj[prop]=this[prop];
            }
        }
        return obj;
    },
    emailRe: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    isValid: function () {
        if (this.props.required && !this.state.value) {
            this.setState({
                error: true
            })
            return false;
        } else if (this.props.textType) {

            if (this.props.textType == 'email' && !ValidMixin.emailRe.test(this.state.value)) {
                this.setState({
                    error: true
                })
            } else {
                this.setState({
                    error: false
                })
            }

        } else {
            this.setState({
                error: false
            })
        }
        return true;
    }
};

class FieldHidden extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }


    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }


    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        return this.state.value;
    }

    render() {
        return (
            <input type="hidden" value={this.props.value} name={this.props.name}/>
        );
    }
}

FieldHidden.propTypes = {
    value: PropTypes.any,
    name: PropTypes.string
};

class FieldText extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        return this.state.value;
    }

    render() {

        let cls = 'field-group form-input-wrapper field-type-field field-type-text';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.state.error) {
            cls += ' field-error';
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let placeholder = this.props.placeholder ? this.props.placeholder : '';

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <input name={this.props.name} type="text" disabled={this.props.disabled} className={fieldCls}
                               value={this.state.value} placeholder={placeholder} onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldText.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    disabled: PropTypes.bool
};

class FieldDate extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }

    componentDidMount() {
        this._isMounted = true;
        let me = this;
        let mainInput = $(ReactDOM.findDOMNode(this.refs.mainInput));
        mainInput.datepicker({
            disabled: this.props.disabled,
            changeMonth: true,
            changeYear: true,
            yearRange: this.props.yearRange,
            onSelect: function () {
                me.setState({value: this.value});
            }
        });
        if (this.state.value) {
            let date = this.state.value.split('-');
            mainInput.datepicker('setDate', new Date(date[0], (date[1] - 1), date[2]));
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        if (this.props.formatGetValue) {
            let value = this.state.value;

            if (value) {
                let dateParts = value.split(' ');

                if (dateParts[0].indexOf('/') !== -1) {
                    dateParts = dateParts[0].split('/');

                    let year = dateParts.pop();
                    let day = dateParts.pop();
                    let month = dateParts.pop();

                    if (year && day && month) {
                        return year + '-' + month + '-' + day;
                    }
                }
            }
            return this.state.value;
        }
        return this.state.value;
    }

    render() {

        let cls = 'field-group form-input-wrapper datepicker-holder field-type-field field-type-date';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field datepicker jquery-ui-datepicker';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        if (this.state.error) {
            cls += ' field-error';
        }

        let placeholder = this.props.placeholder ? this.props.placeholder : '';

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <input ref="mainInput" type="text" className={fieldCls} placeholder={placeholder}
                               onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldDate.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    formatGetValue: PropTypes.bool,
    yearRange: PropTypes.string
};
FieldDate.defaultProps = {
    formatGetValue: false,
    yearRange: "c-100:c+100"
};

class FieldDateTime extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }
    
    componentDidMount() {
        this._isMounted = true;
        let me = this;
        let mainInput = $(ReactDOM.findDOMNode(this.refs.mainInput));
        mainInput.datetimepicker({
            disabled: this.props.disabled,
            changeMonth: true,
            changeYear: true,
            yearRange: "c-100:c+100",
            onSelect: function () {
                me.setState({value: this.value});
            }
        });
        if (this.state.value) {
            mainInput.datetimepicker('setDate', new Date(this.state.value));
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        return this.state.value;
    }

    render() {

        let cls = 'field-group form-input-wrapper datepicker-holder field-type-field field-type-datetime';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field datepicker jquery-ui-datepicker';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        if (this.state.error) {
            cls += ' field-error';
        }

        let val = this.state.value;

        if (val) {
            let valDate = new Date(val);
            val = (valDate.getMonth() + 1) + "/" + valDate.getDate() + "/" + valDate.getFullYear();
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <input ref="mainInput" type="text" className={fieldCls} onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldDateTime.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    disabled: PropTypes.bool
};

class FieldNumber extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        return this.state.value;
    }

    render() {

        let cls = 'field-group form-input-wrapper field-type-field field-type-number';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        if (this.state.error) {
            cls += ' field-error';
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <input disabled={this.props.disabled} type="number" className={fieldCls}
                               value={this.state.value} onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldNumber.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    disabled: PropTypes.bool
};

class FieldTextArea extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        return this.state.value;
    }

    render() {

        let cls = 'field-group form-input-wrapper field-type-field field-type-textarea';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        if (this.state.error) {
            cls += ' field-error';
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <textarea className={fieldCls} name={this.props.name} value={this.state.value}
                                  onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldTextArea.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    disabled: PropTypes.bool
};

class FieldTinyMce extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        if (!this._textAreaId) {
            this._textAreaId = this._guid();
        }
        this.state = {
            value: props.value
        };
    }
    
    componentDidMount() {
        this._isMounted = true;
        let me = this;

        tinyMCE.init({
            disabled: this.props.disabled,
            selector: '#' + this._textAreaId,
            height: 200,
            theme: 'modern',
            plugins: ["link lists code table textcolor"],
            toolbar: "undo redo | styleselect | fontsizeselect | bold italic forecolor | bullist numlist outdent indent",
            statusbar: false,
            readonly: this.props.disabled,
            setup: function (editor) {
                editor.on('init', function () {
                    this.getDoc().body.style.fontSize = '14px';
                });

                editor.on('change', function () {

                    me.setState({
                        value: editor.getContent()
                    })
                });
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        return this.state.value;
    }

    render() {

        let cls = 'field-group form-input-wrapper field-type-field field-type-tinymce';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        if (this.state.error) {
            cls += ' field-error';
        }


        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <textarea disabled={this.props.disabled} name={this.props.name} id={this._textAreaId}
                                  ref="mainInput" className={fieldCls} value={this.state.value}
                                  onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }

    _guid() {
        let S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }

}

FieldTinyMce.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string
};

class FieldCheckbox extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onValueChange(event) {
        this.setState({value: event.target.checked});
    }

    getValue() {
        return this.state.value;
    }

    render() {

        let cls = 'field-group form-input-wrapper field-type-field field-type-checkbox';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        if (this.state.error) {
            cls += ' field-error';
        }


        let field = React.createElement('input', {
            disabled: this.props.disabled,
            type: 'checkbox',
            defaultChecked: !!this.state.value,
            className: fieldCls,
            onClick: this.onValueChange,
            name: this.props.name
        });

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label} {field}
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldCheckbox.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    disabled: PropTypes.bool
};

class FormFieldSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getValue() {
        return this.state.value;
    }

    onSelectChange(event) {
        this.setState({
            value: event.target.value
        });
    }

    render() {

        let cls = 'field-group form-input-wrapper field-group-select field-type-select';
        let fieldHolderCls = 'field-holder select-field-holder form-input-holder edit-field';

        let label = null;
        if (this.props.label) {
            label = <label htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls)
            cls += ' ' + this.props.cls;

        let options = [];

        if (this.props.empty) {
            options.push(
                <option value="" key="empty">{this.props.empty}</option>
            );
        }

        let getOptions = this.props.options;

        if (getOptions) {
            Object.keys(getOptions).map(function (key) {
                options.push(
                    <option key={key} value={key}>{getOptions[key]}</option>
                );
            });
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <select onChange={this.onSelectChange.bind(this)} value={this.state.value}>
                            {options}
                        </select>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FormFieldSelect.propTypes = {
    label: PropTypes.string,
    empty: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.object,
    cls: PropTypes.string
};

class FieldDropdown extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getValue() {
        return this.state.value;
    }

    getDisplayValue() {
        return this.state.displayValue;
    }

    getText() {
        return this.refs.dropdown_field.getText();
    }

    clearValue() {
        return this.refs.dropdown_field.clearValue();
    }

    onDropdownValueChange() {
        //ToDo: Change the value when it's empty as well. For now it's like this because it gets emptied when focusing unfocusing the field
        if (this.refs.dropdown_field.getValue()) {
            let valueParam = {
                value: this.refs.dropdown_field.getValue(),
                displayValue: this.refs.dropdown_field.getText()
            }
            this.setState(valueParam);
            if (this.props.onChange) {
                this.props.onChange(valueParam)
            }
        }
    }

    render() {

        let props = this.props;
        let state = this.state;
        let cls = 'field-group form-input-wrapper field-type-field field-type-dropdown';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        if (this.state.error) {
            cls += ' field-error';
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <ReactFieldDropdown 
                            ref="dropdown_field"
                            disabled={props.disabled}
                            placeholder={props.placeholder}
                            name={props.name}
                            idPath={props.idPath}
                            displayPath={props.displayPath}
                            records={props.records}
                            url={props.url}
                            urlParams={props.urlParams}
                            singleSelect={props.singleSelect}
                            value={props.value}
                            autoLoadFirstId={props.autoLoadFirstId}
                            onChange={this.onDropdownValueChange.bind(this)}
                            hideDeletedValues={props.hideDeletedValues}
                            allowAdditions={props.allowAdditions}
                            customFormat={props.customFormat}
                        />
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldDropdown.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    autoLoadFirstId: PropTypes.bool,

    placeholder: PropTypes.string,
    name: PropTypes.string, // the name of the hidden input
    idPath: PropTypes.arrayOf(PropTypes.string).isRequired,
    displayPath: PropTypes.arrayOf(PropTypes.string).isRequired,
    records: PropTypes.arrayOf(PropTypes.object), // either this or 'url'
    url: PropTypes.string, // either this or 'records'
    urlParams: PropTypes.object, // you should set {limit: 10} or something small to avoid performance issues
    singleSelect: PropTypes.bool,
    search: PropTypes.bool, // set to true to show a search icon instead of a dropdown
    disabled: PropTypes.bool,
    onChange: PropTypes.func, // called exactly the same as here http://semantic-ui.com/modules/dropdown.html#additional-settings
    hideDeletedValues: PropTypes.bool,
    allowClearValue: PropTypes.bool,
    allowAdditions: PropTypes.bool
};
FieldDropdown.defaultProps = {
    allowClearValue: true,
    allowAdditions: false
};

class MultiFieldWrapper extends React.Component {

    constructor(props) {
        super(props);

        FormMixin._composite(this);

        let fieldCollection = {};
        let valuesData = props.options.value ? props.options.value : [];
        let index = 0;

        if (valuesData.length) {
            valuesData.forEach(function (value) {
                fieldCollection[index++] = value
            })
        } else {
            fieldCollection = {
                0: null
            }
        }

        this.state = {
            fieldCls: props.fieldCls,
            options: props.options,
            fieldCollection: fieldCollection,
            fieldIndex: index
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    addField() {
        let state = this.state;

        let fieldIndex = state.fieldIndex;
        fieldIndex++;
        let fieldCollection = state.fieldCollection;
        fieldCollection[fieldIndex] = null;

        this.setState({
            fieldIndex: fieldIndex,
            fieldCollection: fieldCollection
        })
    }

    removeField(index) {
        let state = this.state;
        let fieldCollection = state.fieldCollection;
        let fieldIndex = state.fieldIndex;
        delete fieldCollection[index];

        if (Object.keys(fieldCollection).length == 0) {
            fieldIndex = state.fieldIndex;
            fieldIndex++;
            fieldCollection[fieldIndex] = null;
        }

        this.setState({
            fieldCollection: fieldCollection,
            fieldIndex: fieldIndex
        })

    }

    getValue() {
        let fieldCollection = this.state.fieldCollection;
        let keys = Object.keys(fieldCollection);
        let values = [];
        let val = '';
        keys.forEach(function (key) {
            val = this.refs['field_' + key].getValue();
            if (val || val == 0) {
                values.push(val);
            }

        }.bind(this));
        if (values.length) {
            return values;
        } else {
            return '';
        }

    }

    render() {

        let props = this.props;
        let state = this.state;
        let fieldCollection = state.fieldCollection;

        let fields = [];
        let fieldKeys = Object.keys(fieldCollection);

        fieldKeys.forEach(function (key) {
            let value = fieldCollection[key];
            let name = state.options.name + '[' + key + ']';
            let singleFieldOptions = jQuery.extend(true, {}, state.options)
            singleFieldOptions.key = state.options.key + '_' + key;
            singleFieldOptions.ref = 'field_' + key;

            singleFieldOptions.value = value;
            singleFieldOptions.name = name;


            fields.push(
                <div className="multi-field" key={singleFieldOptions.key}>
                    <div className="field-wrapper">
                        {React.createElement(state.fieldCls, singleFieldOptions)}
                    </div>
                    <div className="field-controls">
                        <div className="field-add fa fa-plus" onClick={this.addField}></div>
                        <div/>
                        <div className="field-remove fa fa-times" onClick={this.removeField.bind(this, key)}></div>
                    </div>
                </div>
            )

        }.bind(this));

        return (
            <div className={'multi-fields  field-type-field ' + (fieldKeys.length == 1 ? 'single-field' : '')}>
                {fields}
                <div className="clearfix"></div>
            </div>
        );
    }
}

MultiFieldWrapper.propTypes = {
    fieldCls: PropTypes.any,
    options: PropTypes.any
};

class FieldImage extends React.Component {

    constructor(props) {
        super(props);
        ValidMixin._composite(this);
        this.state = {
            value: props.value
        };
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    getValue() {
        return this.state.value;
    }

    registerListeners() {
        let holder = $(ReactDOM.findDOMNode(this.refs.image_holder)); // where.find('.person-photo-holder');

        $(document).bind('drop dragover', function (e) {
            e.preventDefault();
        });
        let path = this.props.settings ? (this.props.settings.settings ? (this.props.settings.settings.path) : null) : null;
        let me = this;

        // Path needs to end with /
        if (path.substr(-1) !== "/") {
            path += '/';
        }

        holder.find('.add-image').unbind().bind('click', function (e) {
            e.preventDefault();
            holder.find('.add-image-upload').trigger('click');
        })

        // Upload image
        holder.find('.add-image-upload').on().fileupload({
            url: SS.route('FileManager', 'FileManager', 'imageUploadHandler', 'admin'),
            formData: {
                'data[_Token][key]': SS.csrfToken,
                path: path
            },
            dataType: 'json',
            dropZone: holder.find('.image-upload-holder'),
            // Enable image resizing, except for Android and Opera
            disableImageResize: /Android(?!.*Chrome)|Opera/
                .test(window.navigator.userAgent),
            previewCrop: true, // preview width is set in uploadHandler
            error: function (jqXHR, textStatus, errorThrown) {
                let responseObject = jqXHR.responseText ? JSON.parse(jqXHR.responseText) : null;
                let errorMessage = responseObject && responseObject.name ? responseObject.name : errorThrown;
                me.setState({
                    uploadError: errorMessage
                })
            }.bind(this),
            add: function (e, data) {
                me.setState({
                    progress: 1,
                    uploadError: false
                })
                data.submit();
            }
        }).on('fileuploadprogressall', function (e, data) {
            let progress = parseInt(data.loaded / data.total * 100, 10);
            me.setState({
                progress: progress
            })
        }).on('fileuploaddone', function (e, data) {

            let objMessage = data.result;
            if (objMessage.image) {
                let response = objMessage.image[0];
                if (response.error) {
                    me.setState({
                        uploadError: response.error,
                        progress: false
                    })
                } else {
                    me.setState({
                        value: response.url,
                        progress: false,
                        uploadError: false
                    })
                }
            }
        }.bind(this)).on('fileuploadfail', function (e, data) {
            $.each(data.files, function (index, file) {
                me.setState({
                    uploadError: file.error
                })
            });
        });

        holder.find('button.remove-image').unbind().bind('click', function (e) {
            e.preventDefault();
            me.setState({
                value: null
            }, function () {
                if (this.props.forceChange) {
                    holder.find('.add-image-upload').trigger('click');
                }
            }.bind(this))

        }.bind(this));
    }

    componentDidMount() {
        this._isMounted = true;
        this.registerListeners();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate() {
        this.registerListeners();
    }

    render() {

        let cls = 'field-group form-input-wrapper field-type-field field-type-image';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let photoEl = undefined;
        let progressEl = undefined;
        let errorEl = undefined;
        let uploadEl = undefined;


        if (this.state.progress) {
            let progressStyle = {
                width: this.state.progress + '%'
            }
            progressEl = <div className="content-image-progress">
                <div className="bar" style={progressStyle}></div>
            </div>
        } else {
            if (this.state.uploadError) {
                errorEl = <div class="upload-error">{this.state.uploadError}</div>
                uploadEl = <span className="upload-button-holder">
                    <button className="add-image btn">Add Image</button>
                    <input className="add-image-upload" type="file" name="image"/>
                </span>
            } else if (this.state.value) {
                let resizedPhoto = SS.com.FileManager.frontend.util.Resizer.getResizedPath(this.state.value, 300, 300, null, true);
                photoEl = (
                    <div className="db-image">
                        <img src={resizedPhoto} alt={this.props.label}/>
                        <button
                            className="remove-image btn">{this.props.forceChange ? 'Change Image' : 'Remove Image'}</button>
                    </div>
                );
            } else {
                uploadEl = <span className="upload-button-holder">
                    <button className="add-image btn">Add Image</button>
                    <input className="add-image-upload" type="file" name="image"/>
                </span>
            }

        }


        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <div className="content-image-holder" ref="image_holder">
                            {progressEl}
                            {errorEl}
                            {uploadEl}
                            {photoEl}
                        </div>
                        {/*Warning: `value` prop on `input` should not be null. Consider using an empty string to clear the*/}
                        {/*component or `undefined` for uncontrolled components.*/}
                        <input type="hidden" name={this.props.name}
                               value={(this.state.value !== null) ? this.state.value : undefined}/>
                        <div className="clearfix"></div>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

FieldImage.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    forceChange: PropTypes.bool
};